const registroEnumerators = {
  estado: ['Pendiente', 'Finalizado'],
  categoria: ['General', 'Activo', 'Tarea', 'Usuario'],
  tipo: ['Detención', 'Aviso', 'Prevención', 'Preparación', 'Alarma', 'Afectación'],
  prioridad: ['Muy Alta', 'Alta', 'Media', 'Baja', 'Muy Baja'],
};

export default registroEnumerators;
